import React, { useState } from 'react'
import { CircularProgress, Dialog, DialogContent, Stack, Typography } from '@material-ui/core'
import { useFileDetails } from 'src/api/file/list'
import GeneBrowserTab from 'src/views/VariantDashboard/GeneBrowserTab'
import { getPrimaryFileId } from 'src/views/VariantDashboard/fileUtils'
import SampleToolDialogTitle from './SampleToolDialogTitle'

// igv.js is created imperatively at a fixed height, so size it once from the
// viewport: the 88vh paper minus the title, the gene search row and paddings.
const igvHeightForViewport = () => Math.max(420, Math.round(window.innerHeight * 0.88) - 190)

// Mounted only while the dialog is open, so the file details request runs on
// demand rather than once per table row.
const IgvBrowserBody = ({ fileId, analysisWrapperId }) => {
  const { query } = useFileDetails(fileId)
  const [inlineHeight] = useState(igvHeightForViewport)
  const fileDetails = query.data

  if (!fileDetails) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 300 }}>
        {query.isError ? (
          <Typography variant="body2" color="error">
            The gene browser could not be loaded for this sample.
          </Typography>
        ) : (
          <CircularProgress />
        )}
      </Stack>
    )
  }

  return (
    <GeneBrowserTab
      fileId={getPrimaryFileId(fileDetails)}
      analysisWrapperId={analysisWrapperId}
      inlineHeight={inlineHeight}
    />
  )
}

// IGV gene browser for one sample, opened from the Home analysis table. The
// igv.js frame stays white in both themes (GeneIgv draws it).
const IgvGeneBrowserDialog = ({ open, onClose, fileId, analysisWrapperId, sampleLabel }) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="xl"
    // igv.js opens its own menus and inputs outside the dialog tree.
    disableEnforceFocus
    PaperProps={{ sx: { height: '88vh' } }}
  >
    <SampleToolDialogTitle title="IGV Gene Browser" sampleName={sampleLabel} onClose={onClose} />
    <DialogContent sx={{ overflowY: 'auto' }}>
      <IgvBrowserBody fileId={fileId} analysisWrapperId={analysisWrapperId} />
    </DialogContent>
  </Dialog>
)

export default IgvGeneBrowserDialog
